<!--
  核销员列表
-->
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">产品管理</el-breadcrumb-item>
      <el-breadcrumb-item>产品模块</el-breadcrumb-item>
    </el-breadcrumb>
    <el-container>
      <el-main>
        <!-- 搜索筛选 -->
        <el-form :inline="true" label-position="right" label-width="90px" ref="formInline" :model="formInline" class="user-search">



          <el-form-item label="产品名称" prop="productId">
            <el-select v-model="formInline.productId" placeholder="请选择"  style="height: 33px;width: 250px;">
              <el-option
                  v-for="item in cpList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="模块分类" prop="moduleCateId">
            <el-select v-model="formInline.moduleCateId" placeholder="请选择"  style="height: 33px;width: 250px;">
              <el-option
                  v-for="item in mkList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="产品型号" prop="modelName">
            <el-input size="small" style="width: 200px;" v-model="formInline.modelName" placeholder="产品型号"></el-input>
          </el-form-item>

          <el-form-item label="产品订货号" prop="orderNumber">
            <el-input size="small" style="width: 200px;" v-model="formInline.orderNumber" placeholder="产品订货号"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button size="small" type="primary"  @click="resetFrom" >重置</el-button>
            <el-button size="small" type="primary" icon="el-icon-search" @click="tableList(1)" >搜索</el-button>
            <el-button size="small" type="primary" @click="handleEdit()" >添加</el-button>
            <el-button size="small" type="danger" @click="handlePlDel" >批量删除</el-button>
            <el-button size="small" type="primary" icon="el-icon-download" @click="importExcelItem()">导出数据</el-button>
          </el-form-item>
        </el-form>


        <!--列表-->
        <el-table size="small" ref="tabs" :header-cell-style="{background:'#eef1f6',color:'#606266'}":data="listData"
                  highlight-current-row v-loading="loading" border
                  element-loading-text="拼命加载中" style="width: 100%;"
                  :row-key="(row) => { return row.id }"  @selection-change="handleSelectionChangeDel">


          <el-table-column type="selection" :reserve-selection="true" width="55"></el-table-column>
          <el-table-column prop="id" label="id" align="center"></el-table-column>
          <el-table-column prop="productId" label="产品名称" align="center">
            <template slot-scope="scope">
              <div>{{ scope.row.productId | getCate }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="moduleCateId" label="模块分类" align="center">
            <template slot-scope="scope">
              <div>{{ scope.row.moduleCateId | getModu }}</div>
            </template>
          </el-table-column>

          <el-table-column prop="moduleImg" label="区域模块图" align="center" >
            <template slot-scope="scope">
              <el-popover placement="top-start" trigger="hover">
                <a :href="scope.row.moduleImg" target="_blank" title="查看最大化图片"><img :src="scope.row.moduleImg" style="width: 300px;height: 300px" /></a>
                <img slot="reference" :src="scope.row.moduleImg" style="width: 100px;height: 100px; cursor:pointer" />
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column prop="subtitle" label="模块副标题" align="center"></el-table-column>

          <el-table-column prop="sort" label="排序" align="center"></el-table-column>


          <el-table-column  label="操作" align="left" fixed="right">
            <template slot-scope="scope">
              <el-button size="mini" type="success" @click="handleEdit(scope.row)"style="width: 100px;margin: 1px;">编辑</el-button>
              <el-button size="mini" type="danger" @click="deleteData(scope.row)"style="width: 100px;margin: 1px;">删除</el-button>
            </template>
          </el-table-column>

        </el-table>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>




        <!-- 编辑界面 -->
        <el-dialog :title="title" :visible.sync="editFormVisible" width="60%" @click='closeDialog("edit")':close-on-click-modal="false" :close-on-press-escape="false">
          <el-form label-width="150px" :model="editForm" ref="editForm"  :rules="rules">

            <el-form-item label="产品名称" prop="productId">
              <el-select v-model="editForm.productId" placeholder="请选择"  style="height: 33px;width: 250px;">
                <el-option
                    v-for="item in cpList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="模块分类" prop="moduleCateId">
              <el-select v-model="editForm.moduleCateId" placeholder="请选择"  style="height: 33px;width: 250px;">
                <el-option
                    v-for="item in mkList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="配置模块图" prop="moduleImg">
              <el-upload
                  class="avatar-uploader"
                  :action="this.host+'/upload/file'"
                  :show-file-list="false"
                  :on-success="handleAvatarSuccessImage"
                  :before-upload="beforeAvatarUpload">
                <img v-if="editForm.moduleImg" :src="editForm.moduleImg" class="avatar" width="200">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                <div slot="tip" class="el-upload__tip">请上传图片，建议规格：694*580</div>
              </el-upload>
            </el-form-item>

            <el-form-item label="模块副标题" prop="subtitle">
              <el-input size="small"  v-model="editForm.subtitle" style="width: 300px"  auto-complete="off" placeholder="模块副标题"></el-input>
            </el-form-item>

            <el-form-item label="标签">
              <el-tag
                  :key="tag"
                  v-for="tag in dynamicTags"
                  closable
                  :disable-transitions="false"
                  @close="handleClose(tag)">
                {{tag}}
              </el-tag>
              <el-input
                  class="input-new-tag"
                  v-if="inputVisible"
                  v-model="inputValue"
                  ref="saveTagInput"
                  size="small"
                  @keyup.enter.native="handleInputConfirm"
                  @blur="handleInputConfirm"
              >
              </el-input>
              <el-button v-else class="button-new-tag" size="small" @click="showInput" >+ 添加</el-button>
            </el-form-item>

            <el-form-item label="产品介绍" prop="remark">
              <wangeditor @catchData="catchData" class="catchData margin-top" ref="child"></wangeditor>
            </el-form-item>

            <el-table :data="editForm.productModelList" style="width: 88%; margin-left: 140px">

              <el-table-column prop="modelName" label="产品型号">
                <template slot-scope="scope">
                  <el-input type="textarea" placeholder="产品型号" v-model="scope.row.modelName" style="width: 250px"></el-input>
                </template>
              </el-table-column>

              <el-table-column prop="remark" label="产品描述">
                <template slot-scope="scope">
                  <el-input placeholder="产品描述" v-model="scope.row.remark" style="width: 250px"></el-input>
                </template>
              </el-table-column>

              <el-table-column prop="orderNumber" label="产品订货号">
                <template slot-scope="scope">
                  <el-input placeholder="产品订货号" v-model="scope.row.orderNumber" style="width: 250px"></el-input>
                </template>
              </el-table-column>

              <el-table-column prop="lineImg" label="产品线路图">
                <template slot-scope="scope">
                  <el-upload
                      list-type="picture-card"
                      action="https://api.huceen.com/huichen-ui/upload/files"
                      :show-file-list="false"
                      :on-success="handleAvatarSuccessImageSp"
                      :data="{rowIndex: scope.$index}"
                      :on-progress="onProgress"
                      :before-upload="beforeAvatarUpload">
                    <img v-if="scope.row.lineImg" :src="scope.row.lineImg" class="avatar" alt="" style="width:80px;height: 80px;object-fit: cover;background: #eee;">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </template>
              </el-table-column>

              <el-table-column prop="oneDetailImg" label="一级详情图(宽度649)">
                <template slot-scope="scope">
                  <el-upload
                      list-type="picture-card"
                      action="https://api.huceen.com/huichen-ui/upload/files"
                      :show-file-list="false"
                      :on-success="handleAvatarSuccessImageSpo"
                      :data="{rowIndex: scope.$index}"
                      :on-progress="onProgress"
                      :before-upload="beforeAvatarUpload">
                    <img v-if="scope.row.oneDetailImg" :src="scope.row.oneDetailImg" class="avatar" alt="" style="width:145px;height: 145px;object-fit: cover;background: #eee;">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </template>
              </el-table-column>

              <el-table-column prop="twoDetailImg" label="二级详情图(宽度750)">
                <template slot-scope="scope">
                  <el-upload
                      list-type="picture-card"
                      action="https://api.huceen.com/huichen-ui/upload/files"
                      :show-file-list="false"
                      :on-success="handleAvatarSuccessImageSpot"
                      :data="{rowIndex: scope.$index}"
                      :on-progress="onProgress"
                      :before-upload="beforeAvatarUpload">
                    <img v-if="scope.row.twoDetailImg" :src="scope.row.twoDetailImg" class="avatar" alt="" style="width:145px;height: 145px;object-fit: cover;background: #eee;">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </template>
              </el-table-column>




              <el-table-column  label="操作">
                <template slot-scope="scope">
                  <el-button  type="danger" @click="delFea(scope)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          <el-button style="padding-bottom: 10px;  margin-bottom: 20px; margin-left: 140px;margin-top: 10px;" type="primary" @click="addFea">添加</el-button>

          <el-form-item label="排序" prop="sort">
            <el-input-number :min="0" oninput="if (value < 0) value= null" placeholder="排序" v-model="editForm.sort" style="width: 250px"></el-input-number>
          </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click='closeDialog("edit")'>取消</el-button>
            <el-button size="small" type="primary" class="title" :loading="loading" :disabled="isDisabled" @click="submitForm('editForm')">保存</el-button>
          </div>
        </el-dialog>




      </el-main>
    </el-container>
  </div>
</template>

<script>


import {
  qryModuleContent,
  addModuleContent,
  upModuleContent,
  delModuleContent,
  downloadOContent,
  delModuleContentPl,
  qryModuleCate, qryInfo
} from '../../api/productApi'
import {timestampToTime,parseTime} from "../../utils/util";
import Pagination from '../../components/Pagination'
import ElInputNumber from "../../../node_modules/element-ui/packages/input-number/src/input-number.vue";
import wangeditor from "../../components/wangeditor";
var cpData = [];
var mkData = [];


export default {
  name: "userList",
  filters:{
    getCate(v){
      var name = '';
      cpData.forEach((item,index)=>{
        if(item.id == v) name = item.name
      })
      return name
    },

    getModu(v){
      var name = '';
      mkData.forEach((item,index)=>{
        if(item.id == v) name = item.name
      })
      return name
    },


  },

  data() {
    return {
      title:'修改',
      editFormVisible:false,
      loading: false, //是显示加载
      isDisabled: false,
      formInline:{
        productId:'',
        moduleCateId:'',
        modelName:'',
        orderNumber:'',
        page:1,
        pageSize:10
      },
      listData:[],
      cpList:[],
      mkList:[],
      multipleSelection:[],
      dynamicTags: [],
      inputVisible: false,
      inputValue: '',
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      editForm:{
        id:'',
        productId:'',
        moduleCateId:'',
        moduleImg:'',
        subtitle:'',
        labels:'',
        remark:'',
        sort:'',
        productModelList:[],
      },
      // rules表单验证
      rules: {
        subtitle: [
          { required: true, message: '必填字段不能为空', trigger: 'blur' }
        ],
        moduleImg: [
          { required: true, message: '必填字段不能为空', trigger: 'blur' }
        ],
        moduleCateId: [
          { required: true, message: '必填字段不能为空', trigger: 'blur' }
        ],
        productId: [
          { required: true, message: '必填字段不能为空', trigger: 'blur' }
        ],
      },

    }
  },
  mounted() {
    this.tableList();
    this.qryCp();
    this.qryMod();
  },
  methods:{
    tableList(e){
      if (e == 1){
        this.formInline.page = 1
      }
      this.loading = true;
      qryModuleContent(this.formInline).then(res => {
        this.listData = res.data.list;
        this.pageparm.currentPage = this.formInline.page;
        this.pageparm.pageSize = this.formInline.pageSize;
        this.pageparm.total = res.data.total;
        this.loading = false
      })
    },

    qryMod(){
      qryModuleCate({pageSize:1000}).then(res => {
        this.mkList = res.data.list;
        mkData = res.data.list;
      })
    },

    qryCp(){
      qryInfo({pageSize:1000}).then(res => {
        this.cpList = res.data.list;
        cpData = res.data.list;
      })
    },



    resetFrom(){
      this.formInline.productId = '';
      this.formInline.moduleCateId = '';
      this.formInline.modelName = '';
      this.formInline.orderNumber = '';
      this.formInline.page = 1;
      this.formInline.pageSize = 10;
    },


    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage;
      this.formInline.pageSize = parm.pageSize;
      this.tableList();
    },



    //显示编辑界面
    handleEdit: function(row) {
      if (row != undefined && row != 'undefined') {
        this.title = '修改'
        this.editForm.id = row.id
        this.editForm.productId = row.productId
        this.editForm.moduleCateId = row.moduleCateId
        this.editForm.moduleImg = row.moduleImg
        this.editForm.subtitle = row.subtitle
        this.editForm.labels = row.labels
        this.editForm.remark = row.remark
        this.editForm.sort = row.sort
        if (row.productModelList){
          this.editForm.productModelList = row.productModelList
        }else {
          this.editForm.productModelList = []
        }
        if (row.labels){
          this.dynamicTags = this.editForm.labels.split(",")
        }
        let _this = this;
        setTimeout(() => {
          _this.$refs.child.echo(this.editForm.remark);
        }, 0)

        this.editFormVisible = true
      } else {
        this.title = '添加'
        this.editFormVisible = true
        this.clear()
      }
    },

    clear(){
      this.editForm.id = ''
      this.editForm.productId = ''
      this.editForm.moduleCateId = ''
      this.editForm.moduleImg = ''
      this.editForm.subtitle = ''
      this.editForm.labels = ''
      this.editForm.remark = ''
      this.editForm.sort = ''
      let _this = this;
      setTimeout(() => {
        _this.$refs.child.echo(this.editForm.remark);
      }, 0)
      this.editForm.productModelList = []
    },



    closeDialog(editData){
      this.$refs['editForm'].resetFields();
      this.editFormVisible = false;
      this.tableList()
      this.clear();
    },



    // 编辑、添加提交方法
    submitForm(editData) {
      this.isDisabled = true;
      this.$refs[editData].validate(valid => {
        if (valid) {
          if (this.dynamicTags){
            this.editForm.labels = this.dynamicTags.join(",");
          }
          if(this.editForm.id!=''){
            upModuleContent(this.editForm).then(res =>{
              if (res.code==1) {
                this.editFormVisible = false
                this.$message({
                  type: 'success',
                  message: '数据保存成功！'
                })
                this.tableList()
                this.clear()
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
              this.isDisabled = false;
            }).catch(err => {
              this.editFormVisible = false
              this.$message.error('保存失败，请稍后再试！')
              this.isDisabled = false;
            })
          }
          else{
            addModuleContent(this.editForm)
              .then(res => {
                if (res.code==1) {
                  this.editFormVisible = false
                  this.$message({
                    type: 'success',
                    message: '数据保存成功！'
                  })
                  this.tableList(this.formInline)
                  this.clear()
                } else {
                  this.$message({
                    type: 'info',
                    message: res.msg
                  })
                }
                this.isDisabled = false;
              })
              .catch(err => {
                this.editFormVisible = false
                this.$message.error('保存失败，请稍后再试！')
                this.isDisabled = false;
              })
          }
          // 请求方法
        } else {
          this.isDisabled = false;
          return false
        }
      })
    },



    deleteData(row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          delModuleContent(row)
            .then(res => {
              if (res.code==1) {
                this.$message({
                  type: 'success',
                  message: '数据已更新!'
                })
                this.tableList(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.$message.error('数据删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除！'
          })
        })
    },

    handleSelectionChangeDel(val){
      this.multipleSelection = val;
    },



    handlePlDel() {
      if (this.multipleSelection.length === 0){
        this.$message.error('请选择数据！')
        return
      }
      this.isDisabled = true;
      var data = {
        ids:this.multipleSelection.map(element=>element.id)
      }
      this.$refs.tabs.clearSelection();
      delModuleContentPl(data).then(res =>{
        if (res.code==1) {
          this.$message({
            type: 'success',
            message: '数据保存成功！'
          })
          this.tableList();
        } else {
          this.$message({
            type: 'info',
            message: res.msg
          })
        }
        this.isDisabled = false;
      }).catch(err => {
        this.$message.error('保存失败，请稍后再试！')
        this.isDisabled = false;
      })
    },

    handleAvatarSuccessImage(res) {
      this.editForm.moduleImg = res.data;
    },


    beforeAvatarUpload(file) {
      //const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 10;

      /*if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!');
      }*/
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 10MB!');
      }
      return isLt2M;
    },

    catchData(val){
      this.editForm.remark = val;
    },

    handleAvatarSuccessImageSp(res){
      this.editForm.productModelList[res.data.rowIndex].lineImg = res.data.image;
    },
    handleAvatarSuccessImageSpo(res){
      this.editForm.productModelList[res.data.rowIndex].oneDetailImg = res.data.image;
    },
    handleAvatarSuccessImageSpot(res){
      this.editForm.productModelList[res.data.rowIndex].twoDetailImg = res.data.image;
    },
    onProgress(e) {
    },

    //添加内容
    addFea(){
      this.editForm.productModelList.push({
        id:'',
        moduleContentId:'',
        modelName:'',
        remark:'',
        orderNumber:'',
        lineImg:'',
        oneDetailImg:'',
        twoDetailImg:'',
      })
    },

    delFea(e){
      this.editForm.productModelList.splice(e.$index,1);
    },

    handleClose(tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },

    showInput() {
      if (this.dynamicTags.length >= 3){
        this.$message.error('最多只能上传3个标签!');
        return;
      }else {

        this.inputVisible = true;
        this.$nextTick(_ => {
          this.$refs.saveTagInput.$refs.input.focus();
        });
      }
    },

    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        this.dynamicTags.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = '';
    },

    importExcelItem(){
      downloadOContent(this.formInline).then(res=>{
        let blob = new Blob([res], { type: 'application/vnd.ms-excel' })
        // type值看后台格式,有可能是application/x-xls或application/vnd.ms-excel
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        //配置下载的文件名
        link.download = timestampToTime(new Date())+'产品模块内容.xls'
        link.click()
      });
    },

  },
  //分页组件
  components: {
    ElInputNumber,
    wangeditor,
    Pagination
  }
}



</script>



<style scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/views/product/content.vue